module.exports = __webpack_public_path__ + "img/04b668a17c332608e89c778ddea52129.27e4c778.png";